import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getTypeSwitcherActiveType } from '../../typeSwitcher/store/selectors/getTypeSwitcherActiveType';
import { getActiveBoardId } from '../../../../store/model/selectors/getActiveBoardId';
import { EViewTypes } from '../../../../const';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';

export const kanbanCardRenameCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.KANBAN_CARD_RENAME);
    if (!hint) return false;

    const boardId = getActiveBoardId(state);
    if (
        !boardId ||
        getTypeSwitcherActiveType(state, boardId) !== EViewTypes.KANBAN_VIEW_TYPE
    ) {
        return false;
    }

    return !!getHintCanShow(state, EHintKey.KANBAN_CARD_RENAME);
};
